export var Flags;
(function (Flags) {
    Flags[Flags["ID"] = 15793935] = "ID";
    Flags[Flags["START"] = 15790320] = "START";
    Flags[Flags["END"] = 986895] = "END";
})(Flags || (Flags = {}));
